// NOTE: for styles go to Divider component
const divider = {
  MuiDivider: {
    defaultProps: {
      variant: 'inset',
    },
  },
}

export default divider
